import { render, staticRenderFns } from "./VacationsMain.vue?vue&type=template&id=90724c5a&"
import script from "./VacationsMain.vue?vue&type=script&lang=ts&"
export * from "./VacationsMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports